module.exports = __webpack_public_path__ + "media/init/static/riing_favicon_32x32-cdc64567695af94d91339af760ae469e.png";